import { create } from "zustand";
import { AppConfig } from "@/common/appConfig";

// "Patient consented to recording" for the recording in progress
// (VITE_RECORDING_CONSENT_ENABLED). Kept in memory for the open recorder
// only: every new recording starts unticked. Sent with the visit; the server
// then starts the note with a fixed consent line.
interface RecordingConsentState {
  consented: boolean;
  setConsented: (consented: boolean) => void;
  reset: () => void;
}

export const useRecordingConsentStore = create<RecordingConsentState>()(
  (set) => ({
    consented: false,
    setConsented: (consented): void => {
      set({ consented });
    },
    reset: (): void => {
      set({ consented: false });
    },
  }),
);

/**
 * The `recordingConsent` field for a new visit: present (true) only when the
 * feature is on and the clinician ticked it, so older submissions keep their
 * fingerprint.
 */
export const recordingConsentField = (
  { consented }: { consented: boolean } = useRecordingConsentStore.getState(),
): { recordingConsent?: true } =>
  AppConfig.enableRecordingConsent && consented
    ? { recordingConsent: true }
    : {};
